import styled from 'styled-components';

import Input from 'components/ui/Input';

import { colours } from 'themes/default';

export const AddressContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  > input {
    width: 100%;
  }
`;

export const StyledAddressInput = styled(Input)`
  line-height: 1;
  box-sizing: border-box;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 32px;
  left: 0;
  min-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  color: ${colours.Greyscale.CharcoalGrey};
  padding: 0.3em;
  border-radius: 0.35em;
  background-color: ${colours.Greyscale.White};
  border: 1px solid ${colours.Greyscale.SilverGrey};
  margin: 8px;
  z-index: 2;
`;

export const ListItem = styled.span`
  cursor: pointer;
  width: 100%;
  height: 22px;
  min-height: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 4px 0;
  &:hover {
    background-color: ${colours.Shades.BlueShade20};
  }
`;

export const Errors = styled.span`
  color: red;
`;

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  min-height: 1px;
  background-color: ${colours.Greyscale.SilverGrey};
  margin: 8px 0;
`;

export const ManuallyButton = styled.span`
  cursor: pointer;
  color: ${colours.Shades.TintBlue40};
  margin-left: 4px;
`;

export const BoldText = styled.span`
  font-weight: bold;
`;
